import { useMemo } from 'react';

import { messages } from './ReportCard.messages';
import { ReportCardProps } from './ReportCard.types';

export const usePreviewText = (report: ReportCardProps['report']) => {
    return useMemo(() => {
        const filtersPreviewText: string[] = [];

        switch (report.filterPreviews.length) {
            case 0:
                filtersPreviewText.push(messages.filterPreviewTextAll);
                break;

            case 1:
            case 2:
            case 3:
                filtersPreviewText.push(...report.filterPreviews);
                break;

            default:
                filtersPreviewText.push(...report.filterPreviews.slice(0, 2));
                filtersPreviewText.push(messages.reportTileFilterEllipsisText);
                break;
        }

        return filtersPreviewText;
    }, [report.filterPreviews]);
};
